'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = exports.Body = exports.Footer = exports.Panel = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./Panel.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Panel = exports.Panel = function Panel(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'cj-panel panel panel-default' },
    children
  );
};

var Footer = exports.Footer = function Footer(_ref2) {
  var children = _ref2.children;
  return _react2.default.createElement(
    'div',
    { className: 'cj-panel panel-footer' },
    children
  );
};

var Body = exports.Body = function Body(_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: 'cj-panel panel-body' },
    children
  );
};

var Header = exports.Header = function Header(_ref4) {
  var title = _ref4.title,
      children = _ref4.children;
  return _react2.default.createElement(
    'div',
    { className: 'cj-panel panel-heading' },
    title && _react2.default.createElement(
      'legend',
      null,
      title
    ),
    children
  );
};
Header.propTypes = {
  title: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cjdev/visual-stack/lib/components/Panel.js
// module id = 83
// module chunks = 0